import { render, staticRenderFns } from "./ModalIndicationViewDetail.vue?vue&type=template&id=5664fcaa&scoped=true"
import script from "./ModalIndicationViewDetail.vue?vue&type=script&lang=js"
export * from "./ModalIndicationViewDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalIndicationViewDetail.vue?vue&type=style&index=0&id=5664fcaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5664fcaa",
  null
  
)

export default component.exports